var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasMultiplePages),
      expression: "hasMultiplePages"
    }],
    staticClass: "paginator uk-pagination uk-flex-center",
    attrs: {
      "uk-margin": ""
    }
  }, [_c('li', {
    staticClass: "uk-margin-auto-right",
    class: {
      'uk-disabled': !_vm.hasPrevPage
    }
  }, [_c('paginator-link', {
    attrs: {
      "change-route": _vm.changeRoute,
      "disabled": !_vm.hasPrevPage,
      "page": _vm.prevPage
    },
    on: {
      "change-page": _vm.changePage
    }
  }, [_c('span', {
    staticClass: "uk-margin-small-right",
    attrs: {
      "uk-pagination-previous": ""
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('previous')) + "\n    ")])], 1), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      class: {
        'uk-active': page.value === _vm.currentPage,
          'uk-disabled': page.truncated
      }
    }, [(page.truncated) ? _c('span', [_vm._v("…")]) : _c('paginator-link', {
      attrs: {
        "change-route": _vm.changeRoute,
        "active": page.value === _vm.currentPage,
        "truncate": page.truncated,
        "page": page.value
      },
      on: {
        "change-page": _vm.changePage
      }
    }, [_vm._v("\n      " + _vm._s(page.value) + "\n    ")])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "uk-margin-auto-left",
    class: {
      'uk-disabled': !_vm.hasNextPage
    }
  }, [_c('paginator-link', {
    attrs: {
      "change-route": _vm.changeRoute,
      "disabled": !_vm.hasNextPage,
      "page": _vm.nextPage
    },
    on: {
      "change-page": _vm.changePage
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('next')) + "\n      "), _c('span', {
    staticClass: "uk-margin-small-left",
    attrs: {
      "uk-pagination-next": ""
    }
  })])], 1)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-137f1d26","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Paginator.vue
// module id = 1867
// module chunks = 0